import React, { useCallback, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faPlus, faSave, faSearch, faTimes, faTrash, faUserCheck, faUserSlash } from '@fortawesome/free-solid-svg-icons';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import service from '../../../services/usuarios';
import { actions as actionsSite } from './../../../redux/actions/site';
import { useHistory, useParams } from 'react-router';
import { hasText, isCPF, isEmail } from '../../../utils/utils';

const ConsumidorFinalForm = props => {

    const history = useHistory();
    const params = useParams();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [registro, setRegistro] = useState({});
    const [telefones, setTelefones] = useState([]);
    const { register, handleSubmit, setValue, errors, getValues } = useForm();
    const baseTelefoneObj = {
        _id: null,
        tipo: "",
        ddd: "",
        numero: "",
        contato: "",
        principal: false
    }

    const addField = p => {
        const base = {
            label: p.label || "",
            field: p.field || "",
            type: 'input',
            index: "",
            customValue: false,
            objValue: p.objValue || {},
            validations: p.validations || null
        };
        const params = { ...base, ...p };
        const ret = renderField(params);
        return ret;
    }

    const renderField = p => {
        switch (p.type) {
            case 'input':
                return renderInput(p);
            case 'select':
                return renderSelect(p);
            default:
                return null;
        }
    }
    const changeValueField = (obj, field, value, cb = null) => {
        obj[field] = value;
        if (cb) {
            cb();
        }
    }

    const resetTelefones = () => {
        const _telefones = [...telefones];
        setTelefones(_telefones);
    }

    const renderSelect = p => {
        const id_name = `${p.field}${p.index}`;
        return (
            <div className={errors[id_name] ? "field error" : "field"}>
                {p.customValue &&
                    <select name={id_name} id={id_name} className={"hasText"} ref={register(p.validations)}
                        onChange={(e) => changeValueField(p.objValue, p.field, e.target.value, p.customValue.callback)} value={p.objValue[p.field]}>
                        <option value="">Selecione...</option>
                        {
                            p.options.map((item, index) => {
                                return <option value={item} key={index}>{item}</option>;
                            })
                        }
                    </select>
                }
                {!p.customValue &&
                    <select name={id_name} id={id_name} className={"hasText"} ref={register(p.validations)} defaultValue={p.objValue[p.field]}>
                        <option value="">Selecione...</option>
                        {
                            p.options.map((item, index) => {
                                return <option value={item} key={index}>{item}</option>;
                            })
                        }
                    </select>
                }
                <label htmlFor={id_name}>{p.label}</label>
            </div>
        );
    }

    const renderInput = p => {
        const id_name = `${p.field}${p.index}`;
        return (
            <div className={errors[id_name] ? "field error" : "field"}>
                {p.customValue &&
                    <input name={id_name} id={id_name} type="text"
                        className={p.objValue[p.field] && p.objValue[p.field] !== "" ? "hasText" : ""}
                        onKeyUp={(e) => hasText(e)} ref={register(p.validations)}
                        value={p.objValue[p.field]}
                        onChange={(e) => changeValueField(p.objValue, p.field, e.target.value, p.customValue.callback)} />
                }
                {!p.customValue &&
                    <input name={id_name} id={id_name} type="text"
                        className={p.objValue[p.field] && p.objValue[p.field] !== "" ? "hasText" : ""}
                        onKeyUp={(e) => hasText(e)} ref={register(p.validations)}
                        defaultValue={p.objValue[p.field]}
                    />
                }
                <label htmlFor={id_name}>{p.label}</label>
            </div>
        );
    }

    const addBreak = () => {
        return <div className="break"></div>;
    }

    const buttonAdd = action => {
        return (
            <div className="field botaoAdd">
                <button type="button" onClick={action}><FontAwesomeIcon icon={faPlus} /></button>
            </div>
        );
    }

    const addTelefone = () => {
        const _telefones = [...telefones];

        _telefones.push(baseTelefoneObj);
        setTelefones(_telefones);
    }

    const buttonRmv = (index, action) => {

        return (
            <div className="field botaoRmv">
                <button type="button" onClick={() => action(index)}><FontAwesomeIcon icon={faTrash} /></button>
            </div>
        );

    }

    const rmvTelefone = (index) => {
        const _telefones = [...telefones];
        const obj = _telefones[index];
        if (obj._id && obj._id !== "") {
            openModalRemoveTelefone(index, obj._id);
        } else {
            rmvItemTelefone(index);
        }
    }

    const rmvItemTelefone = (index) => {
        const _telefones = [...telefones];
        _telefones.splice(index, 1);
        setTelefones(_telefones);
    }

    const removerTelefone = async arg => {
        const { index, id } = arg;
        dispatch(actionsSite.setModal(null));
        dispatch(actionsSite.setLoadingMsg("Excluindo telefone..."));
        const res = await service.excluirTelefone(id);
        dispatch(actionsSite.setLoadingMsg(res.msg));
        setTimeout(() => {
            rmvItemTelefone(index);
            dispatch(actionsSite.setLoadingMsg(""));
        }, 3000);
    }

    const openModalRemoveTelefone = (index, id) => {
        const configModal = {
            msg: `Tem certeza que deseja excluir esse telefone?`, title: "Excluir telefone",
            actions: [
                { label: "Sim", class: "azul", callback: removerTelefone, arg: { index, id } },
            ]
        }

        dispatch(actionsSite.setModal(configModal))
    }

    const addTitulo = titulo => {
        return <h3 className="tituloEtapa mt20">{titulo}</h3>;
    }

    const renderFormTelefones = () => {
        if (telefones.length < 1) {
            addTelefone();
        }
        return telefones.map((e, index) => (<React.Fragment key={index}>{renderTelefone(index, e)} {addBreak()}</React.Fragment>));
    }

    const renderTelefone = (index, obj) => {
        const items = [
            addField({ index, label: "Tipo", field: "tipo", type: 'select', options: ["celular","celular (whatsapp)", "recado", "residencial"], objValue: obj, customValue: { callback: resetTelefones }, validations: { required: true } }),
            addField({ index, label: "DDD", field: "ddd", objValue: obj, customValue: { callback: resetTelefones }, validations: { required: true, validate: { isNumeric: value => !isNaN(value) } } }),
            addField({ index, label: "Número", field: "numero", objValue: obj, customValue: { callback: resetTelefones }, validations: { required: true, validate: { isNumeric: value => !isNaN(value) } } }),
            addField({ index, label: "Nome contato", field: "contato", objValue: obj, customValue: { callback: resetTelefones } }),
            buttonAdd(addTelefone),
            buttonRmv(index, rmvTelefone)
        ];

        return items.map((e, i) => (<React.Fragment key={i}>{e}</React.Fragment>));
    }

    const renderForm = () => {
        const items = [
            addField({ label: "Nome", field: "nome", validations: { required: true }, objValue: registro }),
            addBreak(),
            addField({ label: "CPF", field: "cpf", validations: { required: true, validate: { isCPF: value => isCPF(value) } }, objValue: registro }),
            addField({ label: "E-mail", field: "email", validations: { validate: { isEmail: value => isEmail(value) } }, objValue: registro }),
            addBreak(),
            addField({ label: "Observação", field: "observacoes", objValue: registro }),
            addBreak(),
            addTitulo('Telefones'),
            renderFormTelefones(),
        ];

        return items.map((e, i) => (<React.Fragment key={i}>{e}</React.Fragment>));
    }

    const carregarDados = useCallback(async (id) => {
        if (id) {
            const row = await service.getById(id);
            setRegistro(row);
            setTelefones(row.telefones);
        }
        setLoading(false);
    }, []);

    useEffect(() => {
        carregarDados(params.id);
    }, [carregarDados, params.id]);

    const salvar = async (data) => {
        data["telefones"] = telefones;
        dispatch(actionsSite.setLoadingMsg("Enviando dados..."));
        let res;
        if (params.id) {
            res = await service.atualizarUsuario(params.id, data);
            dispatch(actionsSite.setLoadingMsg(res.msg));
        } else {
            res = await service.cadastroConsumidorFinal(data);
            dispatch(actionsSite.setLoadingMsg(res.msg));
        }

        setTimeout(() => {
            dispatch(actionsSite.setLoadingMsg(""));
            if (!params.id && !res.erro) {
                history.push('/painel/consumidorFinal');
            } else {
                setLoading(true);
                carregarDados(params.id);
            }
        }, 3000);
    }

    const tornarRevendedora = async () => {
        dispatch(actionsSite.setLoadingMsg("Enviando dados..."));
        let res = await service.tornarRevendedora(params.id);
        dispatch(actionsSite.setLoadingMsg(res.msg));

        setTimeout(() => {
            dispatch(actionsSite.setLoadingMsg(""));
            history.push('/painel/consumidorFinal');
        }, 3000);
    }

    return (
        <>
            {!loading &&
                <div className="form">
                    <form onSubmit={handleSubmit(salvar)} className="formModule branco">
                        <div className="break"></div>
                        <div className="acoes">
                            <button type="submit" className="salvar"><FontAwesomeIcon icon={faSave} /> {params.id ? 'Editar' : 'Salvar'}</button>
                            {params.id &&
                                <button type="button" className="tornarRev" onClick={() => tornarRevendedora()}><FontAwesomeIcon icon={faUserCheck} /> Tornar Revendedora</button>
                            }
                            <button type="button" className="cancelar" onClick={() => history.goBack()}><FontAwesomeIcon icon={faBan} /> Cancelar</button>
                        </div>
                        <div className="break"></div>
                        {renderForm()}
                        <div className="break"></div>
                        <div className="acoes">
                            <button type="submit" className="salvar"><FontAwesomeIcon icon={faSave} /> {params.id ? 'Editar' : 'Salvar'}</button>
                            {params.id &&
                                <button type="button" className="tornarRev" onClick={() => tornarRevendedora()}><FontAwesomeIcon icon={faUserCheck} /> Tornar Revendedora</button>
                            }
                            <button type="button" className="cancelar" onClick={() => history.goBack()}><FontAwesomeIcon icon={faBan} /> Cancelar</button>
                        </div>
                        <div className="break"></div>
                    </form>
                    {errors && Object.keys(errors).length > 0 &&
                        <div className="erros">
                            <div><FontAwesomeIcon icon={faTimes} /> Existem erros no formulário</div>
                            {/* {errors.nome?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo Nome</div>}
                            {errors.email?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo E-mail</div>}
                            {errors.email?.type === 'isEmail' && <div><FontAwesomeIcon icon={faTimes} /> Digite um E-mail válido</div>}
                            {errors.cpf?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo CPF</div>}
                            {errors.cpf?.type === 'isCPF' && <div><FontAwesomeIcon icon={faTimes} /> Digite um CPF válido</div>}
                            {errors.ddd?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo DDD</div>}
                            {errors.ddd?.type === 'isNumeric' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo DDD com apenas números</div>}
                            {errors.numero?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo Número</div>}
                            {errors.numero?.type === 'isNumeric' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo Número com apenas números</div>} */}
                        </div>
                    }
                </div>
            }

            {loading && "Carregando..."}
        </>
    )
}

export default ConsumidorFinalForm;